import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface DeletePromptModalProps {
  promptTitle: string;
  isLoading?: boolean;
  onDelete: () => void;
  onCancel: () => void;
}

export const DeletePromptModal: FC<DeletePromptModalProps> = ({ promptTitle, isLoading, onDelete, onCancel }) => (
  <StatefulDialog
    name={DialogNames.DeletePrompt}
    actions={
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onDelete} disabled={isLoading}>
          Delete
        </Button>
      </DialogActions>
    }
  >
    <Box minWidth="300px">
      <Typography variant="h6">Are you sure you want to delete the prompt “{promptTitle}”?</Typography>
    </Box>
  </StatefulDialog>
)
